import { Script } from '../../proto/generated/indicator'
import { GetMarketNewsResponse } from '../../proto/generated/market_news'
import { filterDuplicateCandles } from '../../util/chartUtils'
import { CalculateMarginResponse } from '../../proto/generated/order'
import api from './axiosClient'
import { ParticipantData, ParticipantDataList } from '../../proto/generated/open-interest'
import { OptionPositionRequest, OptionPositionResponse } from '../../proto/generated/strategy'

export const getIndicatorScript = async (args: { code: string }): Promise<Script> => {
    return new Promise((resolve, reject) => {
        const url = `/indicators/script`
        api.get(url, {
            headers: {
                Accept: 'application/x-protobuf'
            },
            params: {
                code: args.code
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const decodedData = Script.decode(new Uint8Array(response.data))
                resolve(decodedData)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getMarketNews = async (args: { pageNumber: number; pageSize: number; companyCode: string }): Promise<GetMarketNewsResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/marketnews`
        api.post(
            url,
            JSON.stringify({
                pageNumber: args.pageNumber,
                pageSize: args.pageSize,
                companyCode: args.companyCode
            }),
            {
                headers: {
                    Accept: 'application/x-protobuf'
                },
                responseType: 'arraybuffer'
            }
        )
            .then(async (response) => {
                const decodedData = GetMarketNewsResponse.decode(new Uint8Array(response.data))
                resolve(decodedData)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export const getParticipantData = async (): Promise<ParticipantData[]> => {
    return new Promise((resolve, reject) => {
        const url = `/participant-data`
        api.get(url, {
            headers: {
                'Accept': 'application/x-protobuf'
            },
            responseType: 'arraybuffer'
        })
            .then(async (response) => {
                const participantList = ParticipantDataList.decode(new Uint8Array(response.data))
                resolve(participantList.list as ParticipantData[])
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getMargin = async (args: { body: any }): Promise<CalculateMarginResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/margincalculator/calculate`
        api.post(
            url,
            JSON.stringify(args.body),
            {
                headers: {
                    Accept: 'application/x-protobuf'
                },
                responseType: 'arraybuffer'
            }
        )
            .then(async (response) => {
                const marginData = CalculateMarginResponse.decode(new Uint8Array(response.data))
                resolve(marginData)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getStrategyName = async (args: { body: OptionPositionRequest }): Promise<OptionPositionResponse> => {
    return new Promise((resolve, reject) => {
        const url = `/v2/strategy/name`
        api.post(url,JSON.stringify(args.body),
            {
                headers: {
                    Accept: 'application/x-protobuf'
                },
                responseType: 'arraybuffer'
            }
        ).then((response) => {
                const data = OptionPositionResponse.decode(
                    new Uint8Array(response.data)
                )
                resolve(data)
            })
            .catch((error) => {
                reject(error)
            })
    })
}


export const logExceptions = async (message: any) => {
    return new Promise((resolve, reject) => {
        const url = `/log`
        api.post(
            url,
            JSON.stringify({
                message: JSON.stringify(message),
                timestamp: new Date().getTime()
            }),
            {
                headers: {
                    Accept: 'application/x-protobuf'
                },
                responseType: 'arraybuffer'
            }
        )
            .then(async (response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
};